import React, { forwardRef } from 'react'
import { Controller } from 'react-hook-form'

import TextField from '@/components/Form/TextField'

export const AuthTextField = forwardRef(function AuthTextField (
  { control, name, ...props },
  ref
) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <TextField
          {...props}
          name={name}
          ref={ref || field.ref}
          value={field.value ?? ''}
          onChange={(_, value) => field.onChange(value)}
          errorMessage={fieldState.error?.message}
        />
      )}
    />
  )
})

export default AuthTextField
